/** Flujos de alta de gasto (launcher + wizard). Paridad conceptual con la app móvil. */
export type ExpenseCreateFlow = "pick" | "quick" | "monthly" | "series";

export const EXPENSE_CREATE_WIZARD_REVIEW_STEP = 5;

export function parseExpenseCreateFlowParam(
  raw: string | null,
  options: { fromScan: boolean },
): ExpenseCreateFlow {
  if (options.fromScan) return "quick";
  if (raw === "quick" || raw === "monthly" || raw === "series") return raw;
  return "pick";
}
